import React, { useRef, useState, useEffect } from "react";
import { useLockFn } from "ahooks";
import { Table, Button } from "antd";
import { YhForm } from "@components/YhFormBox";
import { YhBox } from "@src/components/YhBox";
import { SalaryAdjustDrawer } from "./SalaryAdjustDrawer";
import { ColumnsType } from "antd/es/table";
import { useNavModel, RouterParamType } from "@src/model/navModel";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@components/YhFormBox/Types";
import { rosterDetailsModels } from "./rosterDetailsModels";
import { rosterService } from "../../rosterService";
import { globalPrompt } from "@src/components/YhMessage";
import useGlobalModel from "@src/model/globalModel";
import moment from "moment";

export const SalaryFile: React.FC = () => {
  const { user } = useGlobalModel()
  const { getSelectedNavState } = useNavModel();
  const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
  const { id, mode } = detailsInfo;
  const [adjustVisible, setAdjustVisible] = useState(false);
  const {
    loadDs, getDetail, getFormInfo, onCancel,
    skillLevelTypes, salaryTypes,
    salary, salarys, setSalarys,
  } = rosterDetailsModels();

  useEffect(() => {
    loadDs("salaryFile");
    if (mode === "edit") {
      getDetail(id, mode);
    }
  }, [detailsInfo]);

  const formRef = useRef<IYhFormRef>();
  const formConfig: IYhForm = {
    formRef,
    labelCol: { span: 9 },
    disabled: false,
    initialValues: salary,
    justify: 'start',
    items: [
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "",
        fieldName: "id",
        hidden: true,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "开户行",
        fieldName: "bankName",
        span: 8,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "银行卡号",
        fieldName: "bankAccountNumber",
        span: 8,
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "技能级别",
        fieldName: "skillLevel",
        span: 8,
        ds: skillLevelTypes,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "基本工资",
        fieldName: "baseSalary",
        span: 8,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "岗位补贴",
        fieldName: "positionAllowance",
        span: 8,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "技能补贴",
        fieldName: "skillAllowance",
        span: 8,
      },
      {
        type: FormItemTypeEnum.InputNumber,
        fieldLabel: "突出贡献/优秀员工",
        fieldName: "outstandingEmployee",
        span: 8,
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "薪资类型",
        fieldName: "salaryType",
        span: 8,
        ds: salaryTypes,
      }
    ]
  };


  const columns: ColumnsType<any> = [
    {
      align: "center",
      title: "基本工资",
      width: 50,
      dataIndex: "baseSalary",
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "岗位补贴",
      width: 50,
      dataIndex: "positionAllowance",
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "技能补贴",
      width: 50,
      dataIndex: "skillAllowance",
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "调薪时间",
      width: 50,
      dataIndex: "adjustmentDate",
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "调薪原因",
      width: 50,
      dataIndex: "adjustmentReason",
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "操作时间",
      width: 50,
      dataIndex: "createTime",
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "操作人",
      width: 50,
      dataIndex: "operator",
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    }
  ];

  const onSave = useLockFn(async () => {
    try {
      const formData = await formRef.current?.validateFields();
      let salarysData = [{
        ...formData,
        operator: (formData?.operator ?? user.userName),
        adjustmentDate: moment().format('YYYY-MM-DD HH:mm:ss')
      }];
      if (salarys != null && salarys.length > 0) {
        salarysData = salarys?.map((item: any) => {
          if (item.id === formData?.id) {
            return { ...item, ...formData };
          } else {
            return item;
          }
        });
      }
      if (formData) {
        const params = {
          employeeId: id,
          userSalaryRecordsList: salarysData?.map((item: any) => ({
            ...item,
            adjustmentDate: item.adjustmentDate ? moment(item.adjustmentDate).format("YYYY-MM-DD HH:mm:ss") : undefined,
          }))
        };
        const ret = await rosterService.salaryInsert(params);
        if (ret.success) {
          await globalPrompt("message", { type: "success", text: '保存成功!' });
          getDetail(id, mode);
        } else {
          await globalPrompt("message", { type: "error", text: "保存失败!" + ret.retMsg });
        }
      }
    } catch (e) {
      console.log("保存失败!", e);
    }
  });

  const action = (
    <>
      <Button className="mr-5" type="link" shape="round" onClick={() => { onSave() }}>保存</Button>
      <Button className="mr-5" type="link" shape="round" onClick={() => setAdjustVisible(true)}>调薪</Button>
      <Button className="mr-5" type="link" shape="round" onClick={() => { onCancel(mode) }}>取消</Button>
    </>
  );

  return (
    <>
      <YhBox action={action} style={{ overflowY: 'auto', padding: 10, margin: 10 }}>
        <div style={{ padding: 10, fontSize: 18, fontWeight: "bold" }}>薪酬档案</div>
        <YhForm  {...formConfig} />

        <div style={{ marginTop: 10, padding: 10, fontSize: 18, fontWeight: "bold" }}>薪资记录</div>
        <Table
          rowKey={(record, index) => record.id}
          columns={columns}
          dataSource={salarys}
          scroll={{ x: "max-content" }}
          pagination={false}
        />
      </YhBox>

      <SalaryAdjustDrawer
        visible={adjustVisible}
        userInfo={{ ...getFormInfo(mode), id }}
        onCancel={() => {
          getDetail(id, mode);
          setAdjustVisible(false);
        }}
      />
    </>
  );
}